/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.StandardizedInstallTypeRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type GetStandardizedInstallTypeRequest = {
  listingId: number;
  published: boolean;
};

export type GetStandardizedInstallTypeResponse = {
  installType: InstallType;
  updatedAt: number;
  acceptableTransitionTypes: Default<InstallType[]>;
};

export type InstallType =
  | 'STANDARD'
  | 'STANDARD_VULNERABLE'
  | 'HOMEMADE_DATA_SYNC'
  | 'HOMEMADE_DASHWORKS'
  | 'HOMEMADE_MCP_SERVER'
  | 'HOMEMADE_UNIFIED_ACCOUNT'
  | 'HOMEMADE_IFRAME'
  | 'HOMEMADE_MODAL'
  | 'HOMEMADE_PREINSTALLED'
  | 'LINK'
  | 'NONE'
  | 'PARTNER_LINK'
  | unhandledEnumCase;

export type StandardizedInstallTypeError = {
  message: string;
  type: StandardizedInstallTypeErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type UpdateDraftStandardizedInstallTypeRequest = {
  listingId: number;
  installType: InstallType;
  callerPortalId?: number;
};

export type StandardizedInstallTypeErrorType =
  | 'LISTING_NOT_FOUND'
  | 'LISTING_PORTAL_ID_MISMATCH'
  | 'MISSING_PORTAL_ID'
  | 'UNSUPPORTED_PRODUCT_TYPE'
  | 'UNSUPPORTED_INSTALL_TYPE'
  | 'INSTALL_TYPE_NOT_FOUND'
  | 'INVALID_INSTALL_TYPE_TRANSITION'
  | 'UNEXPECTED_ERROR'
  | unhandledEnumCase;

export type GetStandardizedInstallTypeRequestType =
  Requestify<GetStandardizedInstallTypeRequest>;
export type GetStandardizedInstallTypeResponseType =
  GetStandardizedInstallTypeResponse;
export type GetStandardizedInstallTypeErrorType = StandardizedInstallTypeError &
  HubspotMetadata;
export const getStandardizedInstallTypeRpc: ChirpAvroRpcDetails<
  GetStandardizedInstallTypeRequestType,
  GetStandardizedInstallTypeResponseType,
  GetStandardizedInstallTypeErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.listing.details.rpc.StandardizedInstallTypeRpc',
  rpcName: 'getStandardizedInstallType',
  auth: 'app',
  fingerprint: '24vr6NNv6Ln_VyaMjYI-G8-jni124OBK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetStandardizedInstallTypeFromNa1RequestType =
  Requestify<GetStandardizedInstallTypeRequest>;
export type GetStandardizedInstallTypeFromNa1ResponseType =
  GetStandardizedInstallTypeResponse;
export type GetStandardizedInstallTypeFromNa1ErrorType =
  StandardizedInstallTypeError & HubspotMetadata;
export const getStandardizedInstallTypeFromNa1Rpc: ChirpAvroRpcDetails<
  GetStandardizedInstallTypeFromNa1RequestType,
  GetStandardizedInstallTypeFromNa1ResponseType,
  GetStandardizedInstallTypeFromNa1ErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.listing.details.rpc.StandardizedInstallTypeRpc',
  rpcName: 'getStandardizedInstallTypeFromNa1',
  auth: 'app',
  fingerprint: '24vr6NNv6Ln_VyaMjYI-G8-jni124OBK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateStandardizedInstallTypeForDraftListingRequestType =
  Requestify<UpdateDraftStandardizedInstallTypeRequest>;
export type UpdateStandardizedInstallTypeForDraftListingResponseType =
  GetStandardizedInstallTypeResponse;
export type UpdateStandardizedInstallTypeForDraftListingErrorType =
  StandardizedInstallTypeError & HubspotMetadata;
export const updateStandardizedInstallTypeForDraftListingRpc: ChirpAvroRpcDetails<
  UpdateStandardizedInstallTypeForDraftListingRequestType,
  UpdateStandardizedInstallTypeForDraftListingResponseType,
  UpdateStandardizedInstallTypeForDraftListingErrorType,
  false
> = {
  serviceName:
    'com.hubspot.marketplace.listing.details.rpc.StandardizedInstallTypeRpc',
  rpcName: 'updateStandardizedInstallTypeForDraftListing',
  auth: 'app',
  fingerprint: 'KTB_K5SBsQz_VyaMjYI-G8-jni124OBK',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
